import { refuseTransaction } from '@/app/services/transactionService/refuse'
import { ConfirmationModal } from '@/view/components/ConfirmationModal'
import { Button } from '@/view/components/ui/button'
import { FormProvider, useForm } from 'react-hook-form'
import { Dialog, DialogClose, DialogTrigger } from '@/view/components/ui/dialog'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { useQueryClient } from '@tanstack/react-query'
import { useRef } from 'react'
import { useToast } from '@/view/components/ui/use-toast'
import { Textarea } from '@/view/components/ui/textarea'

const schema = z.object({
  reason: z.string().optional(),
})

interface ModalRefuseTransactionProps {
  transactionId: string
}

export const ModalRefuseTransaction = ({
  transactionId,
}: ModalRefuseTransactionProps) => {
  const queryClient = useQueryClient()

  const modalCloseRef = useRef<HTMLButtonElement>(null)

  const form = useForm({
    resolver: zodResolver(schema),
  })

  const { toast } = useToast()

  const handleSubmit = async (formData: any) => {
    try {
      await refuseTransaction(transactionId, formData.reason)

      const cachedData = queryClient.getQueryData<any>([
        'transactions',
        'transactionById',
        transactionId,
      ])

      queryClient.setQueriesData(
        { queryKey: ['transactions', 'transactionById', transactionId] },
        { ...cachedData, status: 'REFUSED', reason_to_cancel: formData.reason },
      )

      toast({ title: 'Transação recusada com sucesso' })
    } catch (error: any) {
      toast({
        title: 'Não foi possível recusar essa transação',
        variant: 'destructive',
      })
    } finally {
      modalCloseRef.current?.click()
    }
  }

  return (
    <FormProvider {...form}>
      <Dialog>
        <DialogClose ref={modalCloseRef} />

        <DialogTrigger className="w-full">
          <Button variant="link" className="mt-4 w-full">
            Recusar transação
          </Button>
        </DialogTrigger>

        <ConfirmationModal
          title="Recusar Proposta"
          onConfirm={form.handleSubmit(handleSubmit)}
          isLoading={form.formState.isSubmitting}
          Content={
            <form>
              Deseja mesmo <b>recusar</b> essa transação? Informe o motivo
              <Textarea
                {...form.register('reason')}
                name="reason"
                className="mt-4"
              />
            </form>
          }
        />
      </Dialog>
    </FormProvider>
  )
}
